<template>
  <div class="contract-sender-bd tb" v-if="funcView.contract_sender_list">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.contractNo"
            :placeholder="$t('crm_contract_sender.qsrhtbh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <span></span>
          <el-button
            type="text"
            size="mini"
            @click="download(scope.row)"
            v-if="funcView.contract_sender_download"
          >{{ funcView.contract_sender_download }}</el-button>
          <el-button
            type="text"
            size="mini"
            @click="preview(scope.row.previewUrl)"
            v-if="funcView.contract_sender_preview"
          >{{ funcView.contract_sender_preview }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 图片预览 -->
    <el-dialog
      v-drag-dialog
      :title="$t('crm_contract_sender.tu_pian_yu_lan')"
      :visible.sync="showImg"
    >
      <img
        width="100%"
        :src="previewImg"
        alt
      />
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';

export default {
  name: 'contract_sender',
  data() {
    return {
      tableCode: 'contract_sender',
      totalRows: null,
      formSearch: {
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractNo: '',
        partyAId: '',
        contractType: [20]
      },
      tableList: [],
      showImg: false,
      previewImg: ''
    };
  },
  methods: {
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getList();
    },
    preview(url) {
      // this.showImg = true;
      // this.previewImg = url;
      window.open(url);
    },
    download(row) {
      // this.$downloadFile(url);
      const { econtractId } = row;
      const url = `/api${apis.OssDownload}/${econtractId}`;
      window.open(url);
    },
    getList() {
      this.$getJSON(apis.econtractPageSender, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    }
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();
    this.getList();
  }
};
</script>

<style></style>
